<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Listagem dos Perfis.</span>
                <br />
                <span class="navigation">Cadastros > Perfil</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-2">
              <label for="filtro">Filtro:</label>
              <span class="p-fluid">
                <InputText type="text" id="filtro" v-model="filtro" />
              </span>
            </div>
            <div class="mb-2">
              <label for="btnSearch">&nbsp;</label>
              <span class="p-fluid">
                <Button
                  label="Pesquisar"
                  title="Pesquisar"
                  icon="pi pi-search"
                  :disabled="search"
                  @click="pesquisar()"
                />
              </span>
            </div>
            <div class="mb-2" style="padding-left:2px">
              <label for="btnSearch">&nbsp;</label>
              <span class="p-fluid">
                <Button
                  label="Limpar"
                  title="Limpar"
                  icon="pi pi-trash"
                  :disabled="search"
                  @click="clear()"
                />
              </span>
            </div>
          </div>
          <div class="row">
            <DataTable
              :value="perfilList"
              :paginator="true"
              :rows="10"
              class="p-datatable-responsive"
              :autoLayout="true"
            >
              <Column headerStyle="width: 8em" bodyStyle="text-align: center">
                <template #body="slotProps">
                  <Button
                    type="button"
                    icon="pi pi-pencil"
                    style="margin-right: .5em"
                    @click="detail(slotProps.data.id)"
                    :disabled="admin === 'N'"
                  ></Button>
                  <Button
                    type="button"
                    icon="pi pi-trash"
                    :disabled="admin === 'N'"
                    @click="confirmRemove(slotProps.data.id)"
                  ></Button>
                </template>
              </Column>
              <Column field="nome" header="Nome"></Column>
            </DataTable>
          </div>
          <hr />

          <div class="row">
            <span class="p-fluid mr-2">
              <router-link to="/perfilCadastro">
                <Button type="button" icon="pi pi-plus" label="Novo" title="Novo" :disabled="admin === 'N'"/>
              </router-link>
            </span>
            <span class="p-fluid">
              <Button
                @click="enviarEmailsPrimeiroAcesso()"
                label="Enviar E-mails de Primeiro Acesso"
                type="button"
                class="p-button-primary mr-2 p-button-danger"
                icon="pi pi-envelope"
                v-show="exibirBotaoPrimeiroAcesso == 'S'"
                :disabled="loading"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
    <Dialog header="Aviso" :visible.sync="display" :style="{width: '30vw'}" :modal="true">
      Confirma a remoção do Registro?
      <template #footer>
        <Button label="Sim" icon="pi pi-check" @click="remove" title="Sim" />
        <Button
          label="Não"
          icon="pi pi-times"
          @click="close"
          title="Não"
          class="p-button-secondary"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import PrimeiroAcessoService from "../services/nfse/primeiro.acesso.service";
import PerfilService from "../services/nfse/perfil.service";

export default {
  name: "perfil",
  data() {
    return {
      loading: false,
      display: false,
      search: false,
      exibirBotaoPrimeiroAcesso: null,
      currentUser: null,
      filtro: "",
      perfilList: [],
      perfilId: null,
      admin: 'N'
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.exibirBotaoPrimeiroAcesso = this.$route.query.primeiroAcesso;
    //só possibilitara a edição se o parametro admin tiver na url usuarios estão indevidamente bloqueando os grupos
    this.admin = (this.$route.query.admin != null && this.$route.query.admin != '' ? this.$route.query.admin : 'N');
    this.pesquisar();
  },
  methods: {
    clear() {
      this.filtro = "";
      this.pesquisar();
    },
    pesquisar() {
      this.search = true;
      PerfilService.findAllByFiltro(
        this.currentUser.usuario.idCliente,
        this.filtro
      ).then(
        perfil => {
          this.perfilList = perfil.data;
        },
        error => {
          let errorMessage = "Houve um problema listar Perfis!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
      this.search = false;
    },
    detail(perfilId) {
      this.$router.push({ name: "perfilCadastro", params: { id: perfilId } });
    },
    confirmRemove(perfilId) {
      this.perfilId = perfilId;
      this.display = true;
    },
    close() {
      this.perfilId = null;
      this.display = false;
    },
    remove() {
      PerfilService.remove(this.perfilId).then(
        data => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Perfil removido com sucesso"
          });
          setTimeout(async () => {
            await this.pesquisar();
            this.display = false;
          }, 250);
        },
        error => {
          let errorMessage = "Houve um problema remover o Perfil!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    },
    enviarEmailsPrimeiroAcesso() {
      this.processando(true);

      PrimeiroAcessoService.enviarEmailsPrimeiroAcesso()
        .then(
          data => {
            console.log(data);

            this.$root.$emit(
              "alert:success",
              "Os emails de primeiro acesso serão enviados!"
            );
          },
          error => {
            console.log(error);

            this.$root.$emit(
              "alert:error",
              "Houve um problema ao enviar os emails de primeiro acesso!"
            );
          }
        )
        .then(this.processando(false));
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    }
  }
};
</script>

<style scoped>
</style>